import { Button, Typography, Box, Paper, Stack } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs from 'dayjs';

interface ScheduledViewProps {
    scheduledTime: string | null;
    specialistName?: string;
    onReschedule: () => void;
}

export default function ScheduledView({ scheduledTime, specialistName = undefined, onReschedule }: ScheduledViewProps) {
    const formattedTime = scheduledTime ? dayjs(scheduledTime).format('MMM D [at] h:mm A') : 'N/A';

    return (
        <Paper
            elevation={1}
            sx={{
                p: 2,
                mb: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 1.5,
            }}>
            <Stack direction="row" gap={1.5} alignItems="center" sx={{ flex: 1 }}>
                <CalendarTodayIcon color="primary" fontSize="medium" sx={{ flexShrink: 0 }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                    {specialistName && (
                        <div>
                            <Typography component="span" variant="body2" color="text.secondary">
                                with{' '}
                            </Typography>
                            <Typography component="span" variant="h6">
                                {specialistName}
                            </Typography>
                        </div>
                    )}
                    <Typography variant="body2" color="text.secondary">
                        {formattedTime}
                    </Typography>
                </Box>
            </Stack>
            <Button onClick={onReschedule} variant="outlined" sx={{ flexShrink: 0, width: '100%' }}>
                Reschedule
            </Button>
        </Paper>
    );
}
